import React from 'react';
import cn from '@/utils/cn';

interface GlossaryTermProps {
  originalText: string;
  selectedTerm: {
    id: number;
    term: string;
    term_es: string;
    definition: string;
    definition_es: string;
    example_sentence?: string;
    example_sentence_es?: string;
    kind: string;
  }
  modelId: number;
  locale: Locale
}

const GlossaryTerm = ({ originalText, modelId, selectedTerm, locale }: GlossaryTermProps) => (
  <span
    className={cn('glossary-term', {
      'tw-text-[#247f99]': selectedTerm.kind !== 'Academic',
      'tw-text-black tw-font-bold': selectedTerm.kind === 'Academic',
    })}
    data-term={locale === 'en' ? selectedTerm.term : selectedTerm.term_es || ''}
    data-term-id={selectedTerm.id}
    data-term-model-id={modelId}
  >
    <strong className="glossary-text tw-underline tw-cursor-pointer">
      {originalText}
    </strong>
  </span>
);

export default GlossaryTerm;
